import { FC, useMemo } from 'react'

import { ITotalItemProps } from './models/iTotalItemProps'

import styles from './TotalItem.module.scss'

export const TotalItem: FC<ITotalItemProps> = ({ title, value }) => {
  const formattedValue = useMemo(() => {
    if (value === null) {
      return '-'
    }

    return value
  }, [value])

  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>{formattedValue}</div>
    </div>
  )
}
